import React from "react";
import { Typography, makeStyles } from "@material-ui/core";

const toneColor = {
  total: "#00d6d6",
  active: "#00d6a4",
  new: "#ffa31a",
};

const useStyles = makeStyles((theme) => ({
  statCard: {
    background: "#111a2b",
    border: "1px solid #1d3454",
    borderRadius: 8,
    borderTop: ({ tone }) => `2px solid ${toneColor[tone] || toneColor.total}`,
    height: 108,
    padding: theme.spacing(2),
  },
  statLabel: {
    color: "#52637c",
    fontSize: 12,
    fontWeight: 900,
    letterSpacing: 1,
    marginBottom: theme.spacing(1.5),
  },
  statValue: {
    color: "#f5f7fb",
    fontSize: 31,
    fontWeight: 900,
    lineHeight: 1,
  },
  statDetail: {
    color: "#b8cdf0",
    fontSize: 12,
    marginTop: theme.spacing(0.75),
  },
}));

const ClientesStatCard = ({ item }) => {
  const classes = useStyles({ tone: item.tone });

  return (
    <div className={classes.statCard}>
      <Typography className={classes.statLabel}>{item.label}</Typography>
      <Typography className={classes.statValue}>{item.value}</Typography>
      <Typography className={classes.statDetail}>{item.detail}</Typography>
    </div>
  );
};

export default ClientesStatCard;
